module.exports = __webpack_public_path__ + "img/icon-edit.91fc056a.svg";